import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-users',
  templateUrl: './help-users.component.html',
  styleUrls: ['./help-users.component.scss']
})
export class HelpUsersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
